import { Box, Divider, Grid } from '@mui/material';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import CustomText from 'components/common/CustomText/CustomText';
import React, { useMemo } from 'react'
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';

interface Props {
  data: any;
}

export default function DiagnosisDetails({ data }: Props) {
  const globalStyles = useGlobalStyles();

  const fields = [
    { label: 'Diagnosis', value: data.procedure_diagnosis },
  ];



  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="Diagnosis"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Grid container p={3} spacing={1.5}>
        {fields.map((field, index) => (
          <React.Fragment key={field.label}>
            <Grid size={{ xs: 12, md: 6 }}>
              <CaseInfoItem
                label={field.label}
                value={field.value}
              />
            </Grid>

            {/* Insert divider after every 2 items, except the last pair */}
            {(index % 2 === 1 && index < fields.length - 1) && (
              <Grid size={12}>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>

    </Box>
  )
}
